import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// login
import LoginReducer from "./auth/login/reducer";

// register
import RegisterReducer from "./auth/register/reducer";

// userProfile
import ProfileReducer from "./auth/profile/reducer";

// Chat
import ChatReducer from "./chat/reducer";


// Ecommerce
import EcommerceReducer from "./ecommerce/reducer";


// Notes
import NotesReducer from "./notes/reducer";


// Invoice
import InvoiceReducer from "./invoice/reducer"

// Users
import UsersReducer from "./users/reducer";

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Register: RegisterReducer,
    Profile: ProfileReducer,
    Chat: ChatReducer,
    Ecommerce: EcommerceReducer,
    Notes: NotesReducer,
    Invoice: InvoiceReducer,
    Users: UsersReducer,
});


export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;